var __jsx = React.createElement;
/** @format */

import React from 'react';
import { ChromeLogo, FirefoxLogo, SafariLogo } from "./style";
var InstallAvailability = function InstallAvailability() {
  return __jsx(React.Fragment, null, "Only available on desktop on", __jsx(ChromeLogo, null), __jsx(FirefoxLogo, null), __jsx(SafariLogo, null));
};
export default InstallAvailability;